<template>
  <div id="BookSuite" class="outer-container">
    <div id="BookSuite-selector"></div>
    <iframe :src="iframeSrc" frameborder="0"></iframe>
  </div>
</template>

<script>
import {
  required,
  minLength,
  email,
  alpha,
  numeric,
} from "vuelidate/lib/validators";
export default {
  name: "BookSuiteForm",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      interest: "",
      submitStatus: null,
      iframeSrc: "form/form.html",
    };
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        console.log(this.submitStatus);
      } else {
        setInterval(this.timestamp(), 500);
        this.submitStatus = "OK";
      }
    },
    timestamp() {
      var response = document.getElementById("g-recaptcha-response");
      if (response == null || response.value.trim() == "") {
        var elems = JSON.parse(
          document.getElementsByName("captcha_settings")[0].value
        );
        elems["ts"] = JSON.stringify(new Date().getTime());
        document.getElementsByName("captcha_settings")[0].value =
          JSON.stringify(elems);
      }
    },
  },
  validations: {
    firstName: {
      required,
      alpha,
    },
    lastName: {
      required,
      alpha,
    },
    email: {
      required,
      email,
    },
    phone: {
      required,
      minLength: minLength(10),
      numeric,
    },
    interest: {
      required,
    },
  },
};
</script>

<style lang="scss" scoped>
.outer-container {
  height: 640px;
  @media only screen and (max-width: $md) {
    height: 1070px;
  }
  iframe {
    background: linear-gradient(135deg, #002d74 0%, #040c18 100%);
    width: 100%;
    height: 100%;
  }
}
</style>
